import { BASE_URL } from '.';

export const api_sendOtp = async (payload: any) => {
	const uri = `${BASE_URL}/users/loginOtp`;
	const response = await fetch(uri, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	}).then((res) => res.json());
	if (!response.isSuccess) {
		throw new Error(response.error || 'something went wrong!');
	}
	return response;
};
export const api_verifyOtp = async (payload: any) => {
	const uri = `${BASE_URL}/users/verifyLoginOtp`;
	const response = await fetch(uri, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	}).then((res) => res.json());
	if (!response.isSuccess) {
		throw new Error(response.error || 'something went wrong!');
	}
	return response;
};
export const api_adminLogin = async (phoneNumber: string, password: string) => {
	const uri = `${BASE_URL}/users/login`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				phoneNumber,
				password,
			}),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to login',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Logged in',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteUser = async (token: string, userID: string) => {
	const uri = `${BASE_URL}/users/${userID}`;
	const response = await fetch(uri, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			authorization: `Bearer ${token}`,
		},
	}).then((res) => res.json());
	if (!response.isSuccess) {
		throw new Error(response.error || 'something went wrong!');
	}
	return response;
};
export const api_updateUser = async (token: string, userID: string, payload: any) => {
	try {
		const uri = `${BASE_URL}/users/${userID}`;
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json', // Add content type header
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to update the user',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'User updated successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error || 'Something went wrong!',
		};
	}
};
